import React, { useEffect, useState } from "react";
// import "antd/dist/antd.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { Sidebar } from "primereact/sidebar";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { getEstimatedDonation, getLast3CyclesSummary, getOccupationBreakdown } from "../../apis/CycleApi";
import {
  getAmountofCurrentCycle,
  getDonationsCount,
  getTotalAmountofCurrentCycle,
  getYearlyDonations,
  getWeeklyDonations,
} from "../../apis/DonationApi";
import "./style.scss";
import icon from "../../images/groupd.png";
// import DonationForm from "../entities/Donation/donationForm";
import AllCycles from "./cycleTile/allCycles";
import PerCycleDonations from "./donationsTile/perCycleDonations";
import TotalDonations from "./donationsTile/totalDonations";

import {
  allCycleDates,
  countOfCycles,
  getLatestCycle,
  perCycleData,
  allCycles,
} from "../../apis/CycleApi";
import {
  currentCycleDeservants,
  // getDeservantCount,
  getCurrentCycleDeservantsCount,
  getCurrentCycleDistributorsCount,
} from "../../apis/CycleDistributorApi";
import { getDeservantCount } from "../../apis/DeservantApi";
import { countDistributors } from "../../apis/DistributorApi";
import CurrentCycleDeservantTile from "../dashboard/DeservantTile/currentcycledeservants";
import Deservant from "../entities/Deservant/Deservant";
import DeservantsChart from "./DeservantsChart/deservantsChart";
import CurrentCycleDistributors from "./distributorTile/currentCycleDistributors";
import TotalDistributors from "./distributorTile/totalDistributors";
import DonationsChart from "./DonationsChart/donationsChart";
import WeeklyDonationsChart from "./EstimatedDonationsChart/estimatedDonationsChart";
//import { allCycles } from "../../../apis/CycleApi";

const StepDashboard = (props) => {
  const [cycleYears, setCycleYears] = useState([]);
  const [cycleData, setCycleData] = useState([]);
  const [latestYear, setLatestYear] = useState();
  const [cycleDonations, setCycleDonations] = useState({});
  const [cycleDeservants, setCycleDeservants] = useState({});
  const [donationCount, setDonationCount] = useState([]);
  const [estimatedAmount, setEstimatedAmount] = useState();
  const [deservantsCount, setDeservantsCount] = useState([]);
  const [currentCycleAmount, setCurrentCycleAmount] = useState();
  const [cycleCount, setCycleCount] = useState([]);
  const [distributorCount, setDistributorCount] = useState([]);
  const [currentCycleDeservant, setCurrentCycleDeservant] = useState([]);
  const [currentCycleCount, setCurrentCycleCount] = useState([]);
  const [yearlyDonation, setYearlyDonation] = useState(0);
  const [currentCycleDeservantsVisible, setCurrentCycleDeservantsVisible] =
    useState(false);
  // const [donationFormVisible, setDonationFormVisible] = useState(false);
  const [currentCycleDonationsVisible, setCurrentCycleDonationsVisible] =
    useState(false);
  const [totalDonationsVisible, setTotalDonationsVisible] = useState(false);
  const [totalDeservantsVisible, setTotalDeservantsVisible] = useState(false);
  const [currentCycleDeservantCount, setCurrentCycleDeservantCount] = useState(
    []
  );
  const [currentCycleDistributorCount, setCurrentCycleDistributorCount] =
    useState([]);
  const [latestCycle, setLatestCycle] = useState([]);

  const [valuesForEdit, setValuesForEdit] = useState();
  const [cycleId, setCycleId] = useState(null);
  const [allCyclesVisible, setAllCyclesVisible] = useState(false);
  const [totalDistributorsVisible, setTotalDistributorsVisible] =
    useState(false);
  const [currentcycleDistributorsVisible, setCurrentCycleDistributorsVisible] =
    useState(false);

  // New state for dashboard charts
  const [cycleSummary, setCycleSummary] = useState([]);
  const [occupationData, setOccupationData] = useState([]);
  const [weeklyData, setWeeklyData] = useState([]);

  const history = useHistory();

  const openTotalDonations = () => {
    setTotalDonationsVisible(true);
  };

  const openCurrentCycleDonations = () => {
    setValuesForEdit(null);
    setCurrentCycleDonationsVisible(true);
  };

  const hideDialogDonation = () => {
    setCurrentCycleDonationsVisible(false);
  };

  const hideDialogTotalDonations = () => {
    setTotalDonationsVisible(false);
  };
  const openTotalDeservants = () => {
    setTotalDeservantsVisible(true);
  };
  const hideDialogTotalDeservants = () => {
    setTotalDeservantsVisible(false);
  };
  const hideDialogTotalDistributors = () => {
    setTotalDistributorsVisible(false);
  };
  const hideDialogCurrentCycleDistributors = () => {
    setCurrentCycleDistributorsVisible(false);
  };

  const openCurrentCycleDeservants = () => {
    setValuesForEdit(null);
    setCurrentCycleDeservantsVisible(true);
  };
  const hideDialogCurrentCycleDeservants = () => {
    setCurrentCycleDeservantsVisible(false);
  };

  const hideDialogAllCycles = () => {
    setAllCyclesVisible(false);
  };

  const loadDonationCount = () => {
    getDonationsCount().then((res) => {
      if (res.status === 200) {
        setDonationCount(res.data);
      }

    });

  };

  const loadYearlyDonations = () => {
    const currentYear = new Date().getFullYear();
    getYearlyDonations(currentYear).then((res) => {
      if (res.status === 200) {
        setYearlyDonation(res.data);
      }
    });
  };

  const {
    formState: { errors },
  } = useForm();

  function CalculateEstimatedAmount() {
    var value = 0;
    if (estimatedAmount > currentCycleAmount) {
      value = estimatedAmount - currentCycleAmount;
      return value;
    } else if (estimatedAmount <= currentCycleAmount) {
      estimatedAmount = 0;
      return estimatedAmount;
    }
  }

  const loadCurrentCycleCount = () => {
    getTotalAmountofCurrentCycle().then((res) => {
      if (res.status === 200) {
        setCycleId(res.data);
        setCurrentCycleCount(res.data);
      }
    });
  };

  const EstAmount = () => {
    getEstimatedDonation().then((res) => {
      if (res.status === 200) {
        setEstimatedAmount(res.data);
        CalculateEstimatedAmount();
      }
    });
  };

  const loadDeservantsCount = () => {
    getDeservantCount().then((res) => {
      if (res.status === 200) {
        setDeservantsCount(res.data);
      }
    });
  };

  const loadCycleDates = () => {
    allCycleDates().then((res) => {
      if (res.status === 200) {
        setCycleYears(res.data);
        setLatestYear(Math.max(...res.data));
      }
    });
  };

  const currentCycleData = () => {
    getAmountofCurrentCycle().then((res) => {
      if (res.status === 200) {
        setCurrentCycleAmount(res.data);
      }
    });
  };
  const loadCountOfCycles = () => {
    countOfCycles().then((res) => {
      if (res.status === 200) {
        setCycleCount(res.data);
      }
    });
  };
  const loadCurrentCycleDeservantCount = () => {
    getCurrentCycleDeservantsCount().then((res) => {
      if (res.status === 200) {
        // setCycleId(res.data);
        setCurrentCycleDeservantCount(res.data);
      }
    });
  };
  const loadCurrentCycleDeservants = () => {
    currentCycleDeservants().then((res) => {
      if (res.status === 200) {
        setCycleId(res.data);
        setCurrentCycleDeservant(res.data);
      }
    });
  };

  const loadCycleCount = () => {
    countOfCycles().then((res) => {
      if (res.status === 200) {
        setCycleCount(res.data);
      }
    });
  };

  const loadDistributorCount = () => {
    countDistributors().then((res) => {
      if (res.status === 200) {
        setDistributorCount(res.data);
      }
    });
  };

  const loadCurrentCycleDistributorCount = () => {
    getCurrentCycleDistributorsCount().then((res) => {
      if (res.status === 200) {
        // setCycleId(res.data);
        setCurrentCycleDistributorCount(res.data);
      }
    });
  };

  const loadLatestCycle = () => {
    getLatestCycle().then((res) => {
      if (res.status === 200) {
        // setCycleId(res.data);
        setLatestCycle(res.data);
      }
    });
  };

  const dashboardApi = (e) => {
    perCycleData(e).then((res) => {
      console.log('API Response:', res);
      if (res.status === 200) {
        setCycleDonations(res.data.cycleDonations);
        setCycleDeservants(res.data.cycleDeservants)
      }
    });
  };

  // Load new dashboard chart data
  const loadDashboardCharts = () => {
    getLast3CyclesSummary().then((res) => {
      if (res.status === 200) {
        setCycleSummary(res.data);
      }
    });

    getOccupationBreakdown().then((res) => {
      if (res.status === 200) {
        setOccupationData(res.data);
      }
    });

    getWeeklyDonations().then((res) => {
      if (res.status === 200) {
        setWeeklyData(res.data);
      }
    });
  };


  useEffect(() => {
    loadDonationCount();
    loadYearlyDonations();
    currentCycleData();
    loadCurrentCycleCount();
    loadCycleCount();
    EstAmount();
    loadDeservantsCount();
    loadCountOfCycles();
    loadCurrentCycleDeservantCount(cycleId);
    loadCurrentCycleDeservants();
    loadDistributorCount();
    loadCurrentCycleDistributorCount(cycleId);
    loadLatestCycle(cycleId);
    loadCycleDates();
    loadDashboardCharts();
  }, []);

  useEffect(() => {
    if (latestYear) {
      dashboardApi(latestYear);
    }
  }, [latestYear]);

  return (
    <React.Fragment>
      <div className="layout-main">
        {/* ── Tiles Row ── */}
        <div className="dashboard-grid">
          {/* Current Cycle Box */}
          <div
            className="
    flex flex-col sm:flex-row items-stretch bg-white rounded-2xl shadow-lg border border-gray-100
    w-full h-auto sm:min-h-[160px] overflow-hidden
  "
          >
            {/* Left section - Active Campaign */}
            <div className="bg-gradient-to-r from-[#0ea5e9] to-[#00D4C6] text-white w-full sm:w-[180px] flex flex-col justify-center items-start p-6 sm:h-full">
              <div className="w-full">
                <span className="text-xs font-bold uppercase tracking-wider opacity-90 mb-1 block">Active Campaign</span>
                <span className="text-xl font-black leading-tight">Current Cycle</span>
                <span className="text-sm font-bold opacity-100 mt-2 block break-all bg-white/20 p-2 rounded-lg text-center">RWP-April2025-2</span>
              </div>
            </div>

            {/* Right section - Progress */}
            <div className="flex-1 w-full sm:w-auto flex flex-row items-center justify-between p-6 gap-4 bg-gray-50/30">
              <div onClick={openCurrentCycleDonations} className="flex flex-col text-left cursor-pointer">
                <span className="text-sm font-black text-gray-400 uppercase tracking-wide mb-2">Collected</span>
                <span className="text-xl font-black text-gray-900 leading-none">
                  {currentCycleCount.toLocaleString()}
                </span>
              </div>
              <div className="h-full border-l-2 border-gray-100"></div>
              <div className="flex flex-col text-right cursor-pointer">
                <span className="text-sm font-black text-gray-400 uppercase tracking-wide mb-2">Required</span>
                <span className="text-xl font-black text-rose-500 leading-none">
                  {(
                    estimatedAmount > currentCycleCount
                      ? estimatedAmount - currentCycleCount
                      : 0
                  ).toLocaleString()}
                </span>
              </div>
            </div>
          </div>


          {/* Yearly Progress Box */}
          <div
            className="
            flex flex-col sm:flex-row items-stretch bg-white rounded-2xl shadow-lg border border-gray-100
            w-full h-auto sm:min-h-[160px] overflow-hidden
          "
          >
            {/* Left section - Yearly Donations */}
            <div
              onClick={openTotalDonations}
              className="cursor-pointer bg-gradient-to-br from-[#0284c7] via-[#0ea5e9] to-[#00D4C6] 
                       text-white w-full sm:w-[180px] flex flex-col justify-center items-start p-6"
            >
              <div className="w-full">
                <span className="text-xs font-bold uppercase tracking-wider opacity-90 mb-1 block">Progress 2026</span>
                <span className="text-xl font-black leading-tight">Collected</span>
                <span className="text-xl font-black mt-2 block whitespace-nowrap">Rs {yearlyDonation?.toLocaleString()}</span>
              </div>
            </div>

            {/* Right section - Metrics */}
            <div className="flex-1 w-full sm:w-auto flex flex-row items-center justify-between p-6 gap-4 bg-gray-50/30">
              <div className="flex flex-col text-left">
                <span className="text-sm font-black text-gray-400 uppercase tracking-wide mb-2">Required</span>
                <span className="text-xl font-black text-rose-500 leading-none">
                  {Math.max(0, 20000000 - yearlyDonation).toLocaleString()}
                </span>
              </div>
              <div className="h-full border-l-2 border-gray-100"></div>
              <div className="flex flex-col text-right">
                <span className="text-sm font-black text-gray-400 uppercase tracking-wide mb-2">Yearly Goal</span>
                <span className="text-lg font-black text-sky-700 leading-none">
                  2.0 Crore
                </span>
              </div>
            </div>
          </div>

          {/* Total Deservants Box */}
          <div
            className="
            cursor-pointer flex flex-col sm:flex-row items-stretch bg-white rounded-2xl shadow-lg border border-gray-100
            w-full h-auto sm:min-h-[160px] overflow-hidden
          "
            onClick={openTotalDeservants}
          >
            {/* Left section - Deservants Title */}
            <div className="bg-gradient-to-br from-[#0284c7] to-[#0ea5e9] text-white w-full sm:w-[180px] flex flex-col justify-center items-start p-6">
              <div className="w-full">
                <span className="text-xs font-bold uppercase tracking-wider opacity-90 mb-1 block">Community Support</span>
                <span className="text-xl font-black leading-tight">Deservants</span>
                <span className="text-base font-bold opacity-90 mt-2 block">All Time Support</span>
              </div>
            </div>

            {/* Right section - Metric & Icon */}
            <div className="flex-1 w-full sm:w-auto flex flex-row items-center justify-between p-6 gap-4 bg-gray-50/50">
              <div className="flex flex-col text-left">
                <span className="text-sm font-black text-gray-400 uppercase tracking-wide mb-2">Total Count</span>
                <span className="text-3xl font-black text-gray-900 leading-none">
                  {deservantsCount?.toLocaleString()}
                </span>
              </div>
              <div className="bg-sky-50 rounded-full p-4 flex justify-center items-center shadow-inner">
                <img src={icon} alt="Deservants" className="w-10 h-10 object-contain grayscale-0 opacity-90" />
              </div>
            </div>
          </div>
        </div>

        {/* ── Sidebars ── */}
        <Sidebar
          visible={totalDonationsVisible}
          position="right"
          style={{ width: "80em" }}
          onHide={() => {
            setTotalDonationsVisible(false);
          }}
        >
          <TotalDonations hide={hideDialogTotalDonations} />
        </Sidebar>

        <Sidebar
          visible={currentCycleDonationsVisible}
          position="right"
          style={{ width: "80em" }}
          onHide={() => {
            setCurrentCycleDonationsVisible(false);
            setValuesForEdit(null);
          }}
        >
          <PerCycleDonations
            cycleDetail={cycleId ? cycleId : ""}
            hide={hideDialogDonation}
            editorValues={valuesForEdit ? valuesForEdit : null}
          />
        </Sidebar>

        <Sidebar
          visible={totalDeservantsVisible}
          position="right"
          style={{ width: "80em" }}
          onHide={() => {
            setTotalDeservantsVisible(false);
          }}
        >
          <Deservant type="dashboard" hide={hideDialogTotalDeservants} />
        </Sidebar>

        <Sidebar
          visible={currentCycleDeservantsVisible}
          position="right"
          style={{ width: "80em" }}
          onHide={() => {
            setCurrentCycleDeservantsVisible(false);
          }}
        >
          <CurrentCycleDeservantTile
            deservantCycle={cycleId ? cycleId : ""}
            hide={hideDialogCurrentCycleDeservants}
          />
        </Sidebar>

        <Sidebar
          visible={allCyclesVisible}
          position="right"
          style={{ width: "80em" }}
          onHide={() => {
            setAllCyclesVisible(false);
          }}
        >
          <AllCycles hide={hideDialogAllCycles} />
        </Sidebar>

        <Sidebar
          visible={totalDistributorsVisible}
          position="right"
          style={{ width: "80em" }}
          onHide={() => {
            setTotalDistributorsVisible(false);
          }}
        >
          <TotalDistributors hide={hideDialogTotalDistributors} />
        </Sidebar>

        <Sidebar
          visible={currentcycleDistributorsVisible}
          position="right"
          style={{ width: "80em" }}
          onHide={() => {
            setCurrentCycleDistributorsVisible(false);
          }}
        >
          <CurrentCycleDistributors
            hide={hideDialogCurrentCycleDistributors}
          />
        </Sidebar>

        {/* ── Charts Row ── */}
        <div className="dashboard-grid dashboard-charts-row">
          <div className="layout-dashborad-donation-graph">
            <div className="aligner-con-header">
              <span className="heading-graphics">Donations & Bags (Last 3 Cycles)</span>
            </div>
            <div className="flex justify-content-center mb-1">
              <DonationsChart cycleSummary={cycleSummary} />
            </div>
            <div className="dashboradcard mb-0"></div>
          </div>

          <div className="layout-dashborad-deservant-graph">
            <div className="aligner-con-header">
              <span className="heading-graphics">Deservant Types</span>
            </div>
            <div className="flex justify-content-center mb-1">
              <DeservantsChart occupationData={occupationData} />
            </div>
            <div className="dashboradcard mb-0"></div>
          </div>

          <div className="layout-dashborad-est-donation-graph">
            <div className="aligner-con-header">
              <span className="heading-graphics">Donations (Last 4 Weeks)</span>
            </div>
            <div className="flex justify-content-center mb-1">
              <WeeklyDonationsChart weeklyData={weeklyData} />
            </div>
            <div className="dashboradcard mb-0"></div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default StepDashboard;
